import { Injectable } from '@angular/core';
import { ApplicationInsights } from '@microsoft/applicationinsights-web';
import { AnalyticsImplementation, AnalyticsPageType } from './analytics.service';
import { ConfigurationData } from '../config.service';
import { Identity, MemberInfo } from '../session-data';
import { SessionService } from '../session.service';

@Injectable({
  providedIn: 'root'
})
export class ApplicationInsightsService implements AnalyticsImplementation {

  constructor(private sessionService: SessionService) {
    this.displayDate = '';
  }

  private displayDate: string;
  private appInsights: ApplicationInsights;

  public init(config: ConfigurationData): void {
    if (!config.appInsightsInstrumentationKey) {
      return;
    }

    this.appInsights = new ApplicationInsights({
      config: {
        instrumentationKey: config.appInsightsInstrumentationKey,
      }
    });
    this.appInsights.loadAppInsights();
  }

  public recordEvent(eventName: string, context: any, data: any) {
    //This is not implemented because we use MetricService for that
  };

  public recordPageView(pageType: AnalyticsPageType, data: any) {
    //This is not implemented because we use MetricService for that
  };

  public trackPageView(pageType: AnalyticsPageType, data: any) {
    var appInsightsData = this.getAppInsightsData();
    this.appInsights.trackPageView({
      name: pageType.toString(),
      pageType: pageType.toString(),
      properties: Object.assign({}, appInsightsData, data)
    });
  };

  public recordException(exception: Error) {
    //This is not implemented
  };

  private getAppInsightsData(): any {
    let sessionData = this.sessionService.getSessionData();
    let identity = sessionData.identity || new Identity();
    let memberInfo = sessionData.memberInfo || new MemberInfo();

    return {
      memberid: memberInfo.member_id,
      ovcpartner: sessionData.partnerId,
      memberclass: identity.ice_member_class_id,
      product: "Car",
      agentid: sessionData.agentId,
      displayoptionsid: sessionData.optionsId
    };
  }
}
